<template>
  <div class="page-content" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'layoutContent',
  props: {
    pTop: Number,
  },
  computed: {
    style() {
      if(this.pTop == null) {
        return {}
      }else{
        return {
          'padding-top' : this.pTop + 'px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  display: flex;
  flex-direction: column;
}
</style>


